/** Keep source slide positions stable while optionally skipping reference material. */
export const adjacentDeckSlideIndex = (
  slides: readonly { id: string }[], index: number, direction: 1 | -1,
  navigationSlideIds?: readonly string[],
): number => {
  for (let next = index + direction; next >= 0 && next < slides.length; next += direction) {
    if (!navigationSlideIds || navigationSlideIds.includes(slides[next].id)) return next;
  }
  return index;
};

/** Explicit deck paths make slide links usable from menus, bookmarks, and other pages. */
export const deckSlideHref = (slideId: string, basePath = ""): string =>
  `${basePath}#${encodeURIComponent(slideId)}`;
